// extracted by mini-css-extract-plugin
module.exports = {"parent":"parent_b0b7M"};